export default __webpack_public_path__ + "static/media/MX.7552b3c4.svg";